module.exports = require('../full/get-iterator-method');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/get-iterator-method.js
// module id = 2038
// module chunks = 25